import { HttpStatusCode } from 'src/utils/enums/http-method.enum';
import { IUser } from 'src/utils/interfaces/user';
import ModalComponent from '../../../../../components/ui/modal';
import { NotificationType } from 'src/components/ui/notification/Notification';
import { PaymentProcessStatus } from 'src/utils/enums/payment.enum';
import { PaymentsService } from 'src/services/payments.service';
import { Permissions } from 'src/utils/enums/permissions.enum';
import QuoteInformation from 'src/views/pages/payments/information/components/QuoteInformation';
import Spinner from 'src/components/ui/spinner';
import { Tabs } from '../../make/index';
import { useLocalization } from 'src/utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import { USER_NAME } from 'src/config';
import ViewInformation from './viewInformation';
import ViewPayment from './viewPayment';
import { getPermissionsMap, isAllow } from 'src/utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
interface IProps {
    payment: any;
    account: any;
    setOpen: any;
    open: boolean;
    loading: boolean;
    reload?: Function;
    tab: Tabs;
}
const details = ({
    payment,
    account,
    setOpen,
    open,
    loading,
    reload,
    tab,
}: IProps) => {
    const emptyNotification = {
        show: false,
        handleShow: () => {
            return;
        },
        type: NotificationType.ERROR,
        content: '',
    };
    const dispatch = useDispatch();
    const { payments } = useLocalization();
    const brand: string = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer.brand || 'vw';
    });
    const dealerNumber = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer.dealerNumber;
    });
    const [deleteState, setDeleteState] = useState(false);
    const [approveState, setApproveState] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [notification, setNotification] = useState(emptyNotification);
    const navigate = useNavigate();
    const permissionsMap: Map<string, Array<string>> = getPermissionsMap();
    const permissionsToken = useSelector((state: IUser) => {
        return state.permissionsToken;
    });
    useEffect(() => {
        if (permissionsToken) {
            const username = sessionStorage.getItem(USER_NAME);
            if (username) {
                setEmail(username);
            }
        }
    }, []);
    function closeModal(value: boolean, deletedata = true) {
        setOpen(value);
        if (deletedata) {
            dispatch({
                type: 'DeletePaymentInfo',
            });
        }
    }
    if (loading && open)
        return (
            <ModalComponent
                bodyContent={
                    <div className='loader_container'>
                        <Spinner />
                    </div>
                }
                open={open}
            ></ModalComponent>
        );
    function accountInfo() {
        if (account)
            return (
                <div className='account-info'>
                    <ViewInformation data={account} />
                </div>
            );
        return null;
    }

    function paymentInfo() {
        if (payment && payment.length) {
            return (
                <ViewPayment
                    payment={payment[0]}
                    accountType={account.accountDetail.accountType}
                    tab={tab}
                />
            );
        }
        return null;
    }

    function quoteInfo() {
        if (account?.quoteDetails)
            return (
                <div className='quote-info'>
                    <QuoteInformation
                        quoteDetails={account.quoteDetails}
                        accountType={account.accountDetail.accountType}
                    />
                </div>
            );
        return null;
    }

    async function deletePayment() {
        setDeleteLoading(true);
        try {
            const service = new PaymentsService();
            const res = await service.paymentDelete({
                dealerId: dealerNumber!,
                ApproverId: email,
                ReferenceNumber: payment[0].PaymentTransactionId,
            });
            if (res !== null) {
                setOpen(false);
                setDeleteState(false);
                if (reload)
                    reload({
                        show: true,
                        type: 'SUCCESS',
                        message:
                            payments.PAYMENT_INFORMATION_DELETE_SUCCESS_MESSAGGE,
                    });
            } else {
                setOpen(false);
                setDeleteState(false);
                if (reload)
                    reload({
                        show: true,
                        type: 'ERROR',
                        message:
                            payments.PAYMENT_INFORMATION_DELETE_ERROR_MESSAGE,
                    });
            }
        } catch (error) {
            setDeleteState(false);
            if (isFundsTransferError(error)) {
                showFundTransferErrorNotification();
            } else if (reload) {
                setOpen(false);
                reload({
                    show: true,
                    type: 'ERROR',
                    message: payments.PAYMENT_INFORMATION_DELETE_ERROR_MESSAGE,
                });
            }
        }
        setDeleteLoading(false);
    }

    async function approvePayment() {
        setDeleteLoading(true);
        const editedpayment = {
            ...payment[0],
            PaymentProcessStatus: Number('1'),
        };
        delete editedpayment.ProcessDateTime;
        try {
            const service = new PaymentsService();
            const res = await service.paymentEdit(editedpayment);
            if (res !== null) {
                setOpen(false);
                setApproveState(false);
                false;
                if (reload)
                    reload({
                        show: true,
                        type: 'SUCCESS',
                        message:
                            payments.PAYMENT_INFORMATION_APPROVE_SUCCESS_MESSAGGE,
                    });
            } else {
                setOpen(false);
                setApproveState(false);
                false;
                if (reload)
                    reload({
                        show: true,
                        type: 'ERROR',
                        message:
                            payments.PAYMENT_INFORMATION_APPROVE_ERROR_MESSAGE,
                    });
            }
        } catch (error) {
            setApproveState(false);
            if (isFundsTransferError(error)) {
                showFundTransferErrorNotification();
            } else if (reload) {
                setOpen(false);
                reload({
                    show: true,
                    type: 'ERROR',
                    message: payments.PAYMENT_INFORMATION_DELETE_ERROR_MESSAGE,
                });
            }
        }
        setDeleteLoading(false);
    }

    function buttonGroup() {
        if (payment && payment.length)
            return (
                <div className='o-fieldset__row u-mt'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/1  u-1/1@xs'>
                            <div className='o-fieldset__row button-group button_group_mobile'>
                                <button
                                    className={
                                        'c-btn u-mr-small ' +
                                        brand.toLocaleLowerCase()
                                    }
                                    type='button'
                                    onClick={() => {
                                        if (deleteState || approveState) {
                                            setDeleteState(false);
                                            setApproveState(false);
                                        } else {
                                            setOpen(false);
                                            dispatch({
                                                type: 'DeletePaymentInfo',
                                            });
                                        }
                                    }}
                                >
                                    <span className='c-btn__text'>
                                        {payments.PAYMENT_INFORMATION_CANCELBTN}
                                    </span>
                                </button>
                                {(isAllow(
                                    [
                                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT,
                                    ],
                                    permissionsMap,
                                    dealerNumber,
                                ) ||
                                    payment[0].PaymentProcessStatus ===
                                        PaymentProcessStatus.PendingApproval) &&
                                !deleteState &&
                                !approveState ? (
                                    <button
                                        className={
                                            'c-btn c-btn--secondary u-mr-small ' +
                                            brand.toLocaleLowerCase()
                                        }
                                        type='button'
                                        onClick={() => {
                                            dispatch({
                                                type: 'PaymentInfo',
                                                payload: {
                                                    payment: payment[0],
                                                },
                                            });
                                            closeModal(false, false);
                                            navigate(
                                                '/dashboard/payments/make',
                                            );
                                        }}
                                        disabled={isFundsTransferInProgress()}
                                    >
                                        <span className='c-btn__text'>
                                            {
                                                payments.PAYMENT_INFORMATION_DETAILS_BUTTONS_EDIT
                                            }
                                        </span>
                                    </button>
                                ) : null}
                                {(isAllow(
                                    [
                                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT,
                                    ],
                                    permissionsMap,
                                    dealerNumber,
                                ) ||
                                    payment[0].PaymentProcessStatus ===
                                        PaymentProcessStatus.PendingApproval) &&
                                    !approveState && (
                                        <button
                                            className={
                                                'c-btn c-btn--secondary u-mr-small ' +
                                                brand.toLocaleLowerCase()
                                            }
                                            type='button'
                                            onClick={() => {
                                                if (!deleteState)
                                                    setDeleteState(
                                                        !deleteState,
                                                    );
                                                else deletePayment();
                                            }}
                                            disabled={isFundsTransferInProgress()}
                                        >
                                            <span className='c-btn__text'>
                                                {!deleteLoading ? (
                                                    payments.PAYMENT_INFORMATION_DETAILS_BUTTONS_DELETE
                                                ) : (
                                                    <Spinner />
                                                )}
                                            </span>
                                        </button>
                                    )}
                                {isAllow(
                                    [
                                        Permissions.DEALER_ELECTRONIC_PAYMENT_SUBMIT_AND_APPROVE,
                                    ],
                                    permissionsMap,
                                    dealerNumber,
                                ) &&
                                payment[0].PaymentProcessStatus ===
                                    PaymentProcessStatus.PendingApproval &&
                                !deleteState ? (
                                    <button
                                        className={
                                            'c-btn c-btn--secondary ' +
                                            brand.toLocaleLowerCase()
                                        }
                                        type='button'
                                        onClick={() => {
                                            if (!approveState)
                                                setApproveState(!approveState);
                                            else approvePayment();
                                        }}
                                        disabled={isFundsTransferInProgress()}
                                    >
                                        <span className='c-btn__text'>
                                            {
                                                payments.PAYMENT_INFORMATION_DETAILS_BUTTONS_APPROVE
                                            }
                                        </span>
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            );
    }

    function contentInfo() {
        return (
            <>
                <>{accountInfo()}</>
                <>{quoteInfo()}</>
                <>{paymentInfo()}</>
                <>{buttonGroup()}</>
            </>
        );
    }

    function showFundTransferErrorNotification() {
        setNotification({
            show: true,
            handleShow: hideNotification,
            type: NotificationType.ERROR,
            content: payments.PAYMENT_DETAILS_FUNDS_ERROR_MESSAGE,
        });
    }

    function hideNotification() {
        setNotification(emptyNotification);
    }

    function isFundsTransferError(err: any) {
        if (err && err.response && err.response.data) {
            const { error } = err.response.data;
            if (error) {
                return error.statusCode == HttpStatusCode.CONFLICT;
            }
        }
        return false;
    }

    function isFundsTransferInProgress() {
        return account?.isFundsTransferInProgress ?? false;
    }
    return (
        <ModalComponent
            titleContent={
                !deleteState
                    ? !approveState
                        ? payments.PAYMENT_INFORMATION_DETAILS_PEDINGTITLE
                        : payments.PAYMENT_INFORMATION_APPROVE_CONFIRMATION_TITLE
                    : payments.PAYMENT_INFORMATION_DELETE_CONFIRMATION_TITLE
            }
            bodyContent={contentInfo()}
            open={open}
            setOpen={closeModal}
            notification={notification}
            footerContent={
                isFundsTransferInProgress()
                    ? payments.PAYMENT_DETAILS_FUNDS_WARNING_MESSAGE
                    : undefined
            }
        />
    );
};

export default details;
